'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityEvents = exports.OauthToken = exports.DeskproWindowEvents = exports.TabEvents = exports.TicketEvents = exports.ContextUserEvents = exports.StorageEvents = exports.UIConstants = exports.UIEvents = exports.AppEvents = exports.App = exports.createAppFromProps = exports.createApp = undefined;

var _createApp = require('./Core/createApp');

Object.defineProperty(exports, 'createApp', {
  enumerable: true,
  get: function get() {
    return _createApp.createApp;
  }
});
Object.defineProperty(exports, 'createAppFromProps', {
  enumerable: true,
  get: function get() {
    return _createApp.createAppFromProps;
  }
});

var _UI = require('./UI');

Object.defineProperty(exports, 'UIEvents', {
  enumerable: true,
  get: function get() {
    return _UI.UIEvents;
  }
});
Object.defineProperty(exports, 'UIConstants', {
  enumerable: true,
  get: function get() {
    return _UI.UIConstants;
  }
});

var _Storage = require('./Storage');

Object.defineProperty(exports, 'StorageEvents', {
  enumerable: true,
  get: function get() {
    return _Storage.StorageEvents;
  }
});

var _Context = require('./Context');

Object.defineProperty(exports, 'TicketEvents', {
  enumerable: true,
  get: function get() {
    return _Context.TicketEvents;
  }
});
Object.defineProperty(exports, 'TabEvents', {
  enumerable: true,
  get: function get() {
    return _Context.TabEvents;
  }
});

var _DeskproWindow = require('./DeskproWindow');

Object.defineProperty(exports, 'DeskproWindowEvents', {
  enumerable: true,
  get: function get() {
    return _DeskproWindow.DeskproWindowEvents;
  }
});

var _Security = require('./Security');

Object.defineProperty(exports, 'OauthToken', {
  enumerable: true,
  get: function get() {
    return _Security.OauthToken;
  }
});
Object.defineProperty(exports, 'SecurityEvents', {
  enumerable: true,
  get: function get() {
    return _Security.SecurityEvents;
  }
});

var _AppClient = require('./Core/AppClient');

var _AppClient2 = _interopRequireDefault(_AppClient);

var _AppEvents = require('./Core/AppEvents');

var AppEvents = _interopRequireWildcard(_AppEvents);

var _ContextUserEvents = require('./Core/ContextUserEvents');

var ContextUserEvents = _interopRequireWildcard(_ContextUserEvents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.App = _AppClient2.default;

/**
 * @type {AppClient}
 */

exports.AppEvents = AppEvents;
exports.ContextUserEvents = ContextUserEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/index.js
// module id = 83
// module chunks = 0